define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/xml"
], function(declare,StringRen,xml) {

	return declare(StringRen, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: render grandparent if parent is a revision or a SupplierItem
			var	node = ctx.getNode();
			
			if (xml.isValidURL(node.Master) && (node.Master != node.$URL)) {
				ctx.pushParams().setNodeURL(node.Master);
				ctx.__popContext = true;
			} else {
				this.inherited(arguments);
			}
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			if (ctx.__popContext) {
				ctx.__popContext = false;
				ctx.pop();
			}

			this.inherited(arguments);
		}
	});
});